import {
  DevelopersManagementView,
  DevelopersProfileManagementView,
} from "../../Views/Home/DevelopersView/DevelopersUtilities";
import { NewDevelopersView } from "../../Views/Home/NewDevelopersView";
export const NewDevelopersCrmRoutes = [
  {
    path: "/view",
    name: "Developers:developers",
    component: NewDevelopersView,
    layout: "/home/developers",
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [],
  },
  {
    path: "/add",
    name: "Developers:developer-management-view",
    component: DevelopersManagementView,
    layout: "/home/developers",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [],
  },
  {
    path: "/developer-profile-edit",
    name: "Developers:developer-profile-edit",
    component: DevelopersProfileManagementView,
    layout: "/home/developers",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [],
  },
];
